<template>
    <div class="authentication">
        <Bar title="模板示例" @goBack="goBack" />
        <div class="authentication-body">
            <img :src="image">
            <p>备注：提交信息必须真实有效，若违规造假，一经发现，或将承担相应的法律责任！</p>
        </div>
        <div class="authentication-footer">
            <van-button class="custom-btn" color="#00CA84" round block @click="handleSavePhoto">保存到手机相册</van-button>
        </div>
    </div>
</template>
<script>
import Bar from '../components/bar.vue'
import { bindAppFn } from '../../utils'
import { Button } from 'vant'
export default {
    name: 'vipCoachAuthenticationTemplate',
    components: {
        Bar,
        [Button.name]: Button
    },
    data () {
        return {
            image: 'https://test.static.public.chetailian.com/cms/advert/1650357228052-picture_gzzm%402x.png'
        }
    },
    methods: {
        // 返回上一页
        goBack () {
            // 上一页是h5 就 返回上一页
            if (this.$route.query.type === 'H5') {
                this.$router.back()
            } else {
                // 上一页是app进入的 就直接返回app
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'exitH5'
                    }
                })
            }
        },
        // 唤起
        handleSavePhoto () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'savePictures',
                    params: {
                        url: this.image
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
img{
    max-width: 100%;
}
.authentication{
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #F3F4FB;
    &-body{
        flex: 1;
        height: 0;
        overflow: auto;
        -webkit-overflow-scrolling: touch;   //该属性随着手指离开还会保持滚动
        overflow-scrolling: touch;
        img{
            min-height: 400px;
        }
        p{
            color:#333;
            margin-top: 15px;
            font-size: 15px;
            line-height: 24px;
        }
    }
    &-footer{
        padding: 7px 15px;
        .custom-btn{
            font-size: 16px;
            height: 46px;
        }
    }
}
</style>
